import React from "react";
import { useTranslation } from "react-i18next";

function Awards() {
  const { t } = useTranslation('about');

  return (
    <>
      {/* Awards Section */}
      <section className="awards-section" style={{
        padding: '120px 0',
        backgroundColor: '#ffffff'
      }}>
        <div className="container">
          <div className="text-center mb-80">
            <h2 style={{
              fontSize: '3rem',
              fontWeight: '700',
              color: '#333',
              marginBottom: '20px'
            }}>
              {t('awards.title')}
            </h2>
            <p style={{
              fontSize: '1.2rem',
              color: '#666',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              {t('awards.subtitle')}
            </p>
          </div>

          <div className="row g-5">
            <div className="col-lg-4 col-md-6">
              <div className="award-card" style={{
                position: 'relative',
                height: '650px',
                borderRadius: '28px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 25px 60px rgba(0,0,0,0.15)'
              }}
              onClick={() => window.location.href = '/projects/bellemare'}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-18px)';
                e.currentTarget.style.boxShadow = '0 35px 70px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.15)';
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: 'url(/projects/BelleMare/IMG_4750.JPG)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}></div>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(0,0,0,0.7), rgba(0,0,0,0.4))'
                }}></div>
                
                {/* Award Star */}
                <div style={{
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  width: '45px',
                  height: '45px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  borderRadius: '50%',
                  boxShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 4px 15px rgba(0,0,0,0.3)',
                  zIndex: 2,
                  animation: 'pulse 2s infinite'
                }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFD700">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  padding: '50px 40px 40px',
                  color: 'white'
                }}>
                  <div style={{
                    fontSize: '1.1rem',
                    fontWeight: '700',
                    color: 'rgb(200, 195, 180)',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.buildingOfYear.category')}
                  </div>
                  <h3 style={{
                    fontSize: '2.2rem',
                    fontWeight: '800',
                    marginBottom: '15px',
                    lineHeight: '1.2',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.buildingOfYear.title')}
                  </h3>
                  <p style={{
                    fontSize: '1.2rem',
                    opacity: '0.98',
                    margin: 0,
                    lineHeight: '1.6',
                    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.buildingOfYear.description')}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="award-card" style={{
                position: 'relative',
                height: '650px',
                borderRadius: '28px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 25px 60px rgba(0,0,0,0.15)'
              }}
              onClick={() => window.open('https://www.buildingoftheyear.bg/bg/uchastnici/ot10do20/petijat-element', '_blank')}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-18px)';
                e.currentTarget.style.boxShadow = '0 35px 70px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.15)';
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: 'url(/home1/assets/img/slider/IMG_0578.jpeg)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}></div>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(0,0,0,0.7), rgba(0,0,0,0.4))'
                }}></div>
                
                {/* Award Star */}
                <div style={{
                  position: 'absolute',
                  top: '30px',
                  right: '30px',
                  width: '45px',
                  height: '45px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  borderRadius: '50%',
                  boxShadow: '0 0 20px rgba(255, 215, 0, 0.8), 0 4px 15px rgba(0,0,0,0.3)',
                  zIndex: 2,
                  animation: 'pulse 2s infinite'
                }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFD700">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                </div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  padding: '50px 40px 40px',
                  color: 'white'
                }}>
                  <div style={{
                    fontSize: '1.1rem',
                    fontWeight: '700',
                    color: 'rgb(200, 195, 180)',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.fifthElement.category')}
                  </div>
                  <h3 style={{
                    fontSize: '2.2rem',
                    fontWeight: '800',
                    marginBottom: '15px',
                    lineHeight: '1.2',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.fifthElement.title')}
                  </h3>
                  <p style={{
                    fontSize: '1.2rem',
                    opacity: '0.98',
                    margin: 0,
                    lineHeight: '1.6',
                    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.fifthElement.description')}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="award-card" style={{
                position: 'relative',
                height: '650px',
                borderRadius: '28px',
                overflow: 'hidden',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 25px 60px rgba(0,0,0,0.15)'
              }}
              onClick={() => window.location.href = '/innerpages/portfolio'}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-18px)';
                e.currentTarget.style.boxShadow = '0 35px 70px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.15)';
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: 'url(/home1/assets/img/slider/head_slide1.jpg)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}></div>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(0,0,0,0.7), rgba(0,0,0,0.4))'
                }}></div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  left: '0',
                  right: '0',
                  padding: '50px 40px 40px',
                  color: 'white'
                }}>
                  <div style={{
                    fontSize: '1.1rem',
                    fontWeight: '700',
                    color: 'rgb(200, 195, 180)',
                    marginBottom: '15px',
                    textTransform: 'uppercase',
                    letterSpacing: '2px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.bigSeaArchitecture.category')}
                  </div>
                  <h3 style={{
                    fontSize: '2.2rem',
                    fontWeight: '800',
                    marginBottom: '15px',
                    lineHeight: '1.2',
                    textShadow: '0 2px 4px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.bigSeaArchitecture.title')}
                  </h3>
                  <p style={{
                    fontSize: '1.2rem',
                    opacity: '0.98',
                    margin: 0,
                    lineHeight: '1.6',
                    textShadow: '0 1px 2px rgba(0,0,0,0.5)'
                  }}>
                    {t('awards.bigSeaArchitecture.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* CSS Animation for Star Pulse */}
      <style>{`
        @keyframes pulse {
          0% {
            box-shadow: 0 0 20px rgba(255, 215, 0, 0.6), 0 4px 15px rgba(0,0,0,0.3);
          }
          50% {
            box-shadow: 0 0 30px rgba(255, 215, 0, 0.8), 0 4px 20px rgba(0,0,0,0.4);
          }
          100% {
            box-shadow: 0 0 20px rgba(255, 215, 0, 0.6), 0 4px 15px rgba(0,0,0,0.3);
          }
        }
      `}</style>
    </>
  );
}

export default Awards;